import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, SVGIcon, Button, ButtonGroup } from 'components/qstrap'

const AptitudeQuestionItemCharcs = (props) => {
  const buttons = []
  let answerValues

  if (props.content.reverse) {
    answerValues = [4, 3, 2, 1]
  } else {
    answerValues = [1, 2, 3, 4]
  }

  [
    <div><SVGIcon name="common-back" size="sm" /><SVGIcon name="common-back" /></div>,
    <SVGIcon name="common-back" />,
    <SVGIcon name="common-next" />,
    <div><SVGIcon name="common-next" /><SVGIcon name="common-next" size="sm" /></div>,
  ].forEach((value, index) => {
    const activeClass = ((answerValues[index]) === props.answer) ? 'active' : ''

    buttons.push(
      <Button
        className={`${activeClass} charcs-btn`}
        onClick={() => { props.onClickHandler(answerValues[index]) }}
        key={index}
        data-answer-id={`${props.number}-${index + 1}`}
        data-testid={`${props.number}-${index + 1}`}
      >
        {value}
      </Button>
    )
  })

  return (
    <div className="charcs-item">
      <Row>
        <Col sm="6" md="6" className="question-text col-xs-6">{props.content.charcs_question_left}</Col>
        <Col sm="6" md="6" className="question-text col-xs-6">{props.content.charcs_question_right}</Col>
      </Row>

      <ButtonGroup>{buttons}</ButtonGroup>
      <hr />
    </div>
  )
}

AptitudeQuestionItemCharcs.propTypes = {
  content: PropTypes.object.isRequired,
  number: PropTypes.number.isRequired,
  answer: PropTypes.number.isRequired,
  onClickHandler: PropTypes.func,
}

AptitudeQuestionItemCharcs.defaultProps = {
  onClickHandler: () => {},
}

export default AptitudeQuestionItemCharcs
